export default __webpack_public_path__ + "static/media/Comp_6.e59baac7.gif";